// Helper agnóstico de plataforma para enviar eventos a Google Tag Manager.
// El sitio empuja un evento semántico al dataLayer; en GTM (lo administra el
// equipo de marketing) se mapea ese evento a las etiquetas de Meta Pixel /
// Google Ads que correspondan. Así las campañas pueden optimizar hacia
// conversiones reales (y, con `lead_qualified`, hacia leads de calidad).

type DataLayerEvent = Record<string, unknown>

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[]
  }
}

export function pushToDataLayer(event: DataLayerEvent): void {
  if (typeof window === "undefined") return
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(event)
}

/**
 * Dispara el evento de lead del formulario de contacto.
 * `units` es el rango elegido; `qualified` es false para "Menos de 50 unidades"
 * (por debajo del mínimo de producción), para que las campañas optimicen
 * hacia los leads que realmente sirven.
 */
export function trackContactLead(units: string): void {
  pushToDataLayer({
    event: "generate_lead",
    form_id: "contact",
    units,
    lead_qualified: units !== "Menos de 50 unidades",
  })
}
